import React, { useState, useMemo, useContext } from 'react';
import axios from 'axios';
import SingleItemDetailTemplate from '../../../Reusable_Components/SingleItemDetailTemplate';
import { useParams, useNavigate } from 'react-router-dom';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { ToastContext } from '../../../../context/ToastContext';
import ConfirmModal from '../../../Reusable_Components/ConfirmModal';
import useDetailFetch from '../../../../hooks/useDetailFetch';

const SingleTrendAnalysisDetails = () => {
  const { trendId } = useParams();
  const navigate = useNavigate();
  const decodedId = trendId ? atob(trendId) : trendId;
  const id = decodedId.replace(/\D/g, '');
  const [showDelete, setShowDelete] = useState(false);
  const { showToast } = useContext(ToastContext);

  const url = id ? `${API_DOMAIN}${API_ROUTES['trendAnalysis']}${id}/` : null;
  const { data: details, loading } = useDetailFetch(url);

  const columns = useMemo(() => {
    if (!details) return null;
    const excluded = ['id', 'updated_at', 'created_at'];
    return Object.keys(details)
      .filter(c => !excluded.includes(c))
      .map(c => ({ label: c.charAt(0).toUpperCase() + c.slice(1), field: c }));
  }, [details]);

  const handleDelete = async () => {
    try {
      await axios.delete(API_DOMAIN + API_ROUTES['trendAnalysis'] + id + '/', { headers });
      showToast('Trend Analysis deleted successfully', 'success');
      navigate('/reporting/trend/list');
    } catch (error) {
      console.error('Error deleting Trend Analysis:', error);
      showToast('Error deleting Trend Analysis', 'error');
    }
  };

  return (
    <div>
      <SingleItemDetailTemplate
        details={details}
        columns={columns}
        entityName="Trend Analysis"
        listPath="/reporting/trend/list"
        editPath={`/reporting/trend/input/${btoa(id)}`}
        onDelete={() => setShowDelete(true)}
        loading={loading}
      />
      <ConfirmModal
        isOpen={showDelete}
        title="Delete Trend Analysis"
        message="Are you sure you want to delete this trend analysis? This action cannot be undone."
        onConfirm={() => {
          setShowDelete(false);
          handleDelete();
        }}
        onCancel={() => setShowDelete(false)}
      />
    </div>
  );
};

export default SingleTrendAnalysisDetails;